// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperModal-cls1_Kfc","cls2":"MultiPaperModal-cls2_aDo MultiPaperModal-cls1_Kfc"};